import BaseService from '@/services/BaseService'
import {http} from './config'
class TransferenciaEstoqueService extends BaseService {
    constructor(){
        super('/v1/transferencias-estoques')
    }

    imprimir(id){
        return http.get(`/v1/transferencia/${id}/comprovante`)
    }
}

export default new TransferenciaEstoqueService